import { createFileRoute } from "@tanstack/react-router";

import { LegalList, LegalPage, LegalSection } from "~/components/legal-page";

export const Route = createFileRoute("/conditions")({
  component: TermsPage,
});

// ⚠️  MODÈLE À FAIRE VALIDER PAR UN CONSEIL JURIDIQUE avant publication.
//     Complétez les mentions entre crochets [ ] (raison sociale, ville
//     du tribunal compétent).
const UPDATED_AT = "9 juillet 2026";

function TermsPage() {
  return (
    <LegalPage
      title="Conditions d'utilisation"
      updatedAt={UPDATED_AT}
      intro="Les présentes conditions régissent l'utilisation de l'application Gately et de la console d'administration. En utilisant Gately, vous acceptez ces conditions. Si vous ne les acceptez pas, n'utilisez pas le service."
    >
      <LegalSection n={1} title="Objet">
        <p>
          Gately est un service de gestion des accès permettant aux résidences
          et resorts d'émettre des invitations et des laissez-passer, de gérer
          les résidents et concierges, et de tenir un journal d'accès. Le
          service est édité par [Raison sociale de l'éditeur] (« Gately », «
          nous »).
        </p>
      </LegalSection>

      <LegalSection n={2} title="Accès et compte">
        <p>
          L'accès à Gately se fait sur invitation d'un gestionnaire de résidence
          ; il n'existe pas d'inscription libre. Votre compte est lié à votre
          numéro de téléphone, qui sert d'identifiant. Vous êtes responsable de
          la confidentialité de votre appareil et du code de vérification reçu.
        </p>
      </LegalSection>

      <LegalSection n={3} title="Utilisation acceptable">
        <p>Vous vous engagez à ne pas :</p>
        <LegalList
          items={[
            "utiliser le service à des fins illégales ou frauduleuses ;",
            "partager vos laissez-passer ou codes d'accès avec des personnes non autorisées ;",
            "tenter d'accéder à des données ou comptes qui ne vous appartiennent pas ;",
            "perturber, surcharger ou compromettre la sécurité du service ;",
            "publier des contenus illicites, offensants ou portant atteinte aux droits de tiers.",
          ]}
        />
      </LegalSection>

      <LegalSection n={4} title="Laissez-passer et accès">
        <p>
          Les laissez-passer QR que vous générez engagent votre responsabilité :
          vous en contrôlez le partage et la durée de validité. Le gestionnaire
          de la résidence et les concierges peuvent vérifier, suspendre ou
          révoquer un accès, et consulter le journal des entrées pour des motifs
          de sécurité.
        </p>
      </LegalSection>

      <LegalSection n={5} title="Disponibilité du service">
        <p>
          Nous nous efforçons d'assurer la disponibilité du service mais ne
          garantissons pas un fonctionnement ininterrompu ou exempt d'erreurs.
          Le service peut être suspendu pour maintenance ou pour des raisons
          techniques ou de sécurité.
        </p>
      </LegalSection>

      <LegalSection n={6} title="Responsabilité">
        <p>
          Le service est fourni « en l'état ». Dans les limites permises par la
          loi, Gately ne saurait être tenue responsable des dommages indirects
          résultant de l'utilisation ou de l'impossibilité d'utiliser le
          service. Gately n'est pas responsable des décisions d'admission ou de
          refus d'accès prises par la résidence ou ses agents.
        </p>
      </LegalSection>

      <LegalSection n={7} title="Propriété intellectuelle">
        <p>
          L'application, son code, ses marques et ses contenus sont la propriété
          de Gately ou de ses concédants. Aucun droit ne vous est cédé au-delà
          du droit d'utiliser le service conformément aux présentes conditions.
        </p>
      </LegalSection>

      <LegalSection n={8} title="Suspension et résiliation">
        <p>
          Nous pouvons suspendre ou clôturer un compte en cas de manquement aux
          présentes conditions ou à la demande du gestionnaire de la résidence.
          Vous pouvez à tout moment supprimer votre compte depuis l'application
          (onglet Compte).
        </p>
      </LegalSection>

      <LegalSection n={9} title="Données personnelles">
        <p>
          Le traitement de vos données personnelles est décrit dans notre{" "}
          <a href="/confidentialite" className="text-primary">
            politique de confidentialité
          </a>
          , qui fait partie intégrante des présentes conditions.
        </p>
      </LegalSection>

      <LegalSection n={10} title="Droit applicable et litiges">
        <p>
          Les présentes conditions sont régies par le droit marocain. Tout
          litige relatif à leur interprétation ou exécution relève de la
          compétence des tribunaux de [ville], à défaut de résolution amiable.
        </p>
      </LegalSection>

      <LegalSection n={11} title="Modifications">
        <p>
          Nous pouvons modifier ces conditions. En cas de changement important,
          nous vous en informerons dans l'application. La poursuite de
          l'utilisation vaut acceptation des conditions mises à jour.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
